export default __webpack_public_path__ + "images/36_1_image.jpg";